import { SaleManageable } from "./types";

export const STORE_SALES_ACTION = "store_sales";

interface StoreSalesAction {
  type: typeof STORE_SALES_ACTION;
  payload: {
    sales: Array<SaleManageable>;
  };
}

export type Action = StoreSalesAction;
